<template>

 <scroll-page :pull-reload="true">
   <page-padding v-if="computeUserAccess">
      <button-action  :to="'/group/'+id+'/photoalbum/add/'" title="language.add_photoalbum" ></button-action>
   </page-padding>
  
    <list-albums :group_id="group.id" :group_name="group.name"/>
</scroll-page>

</template>

<script>

import { mapState } from 'vuex';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import ListAlbums from '../components/albums/ListAlbums';
import ScrollPage from '../components/ScrollPage.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';

export default {
  name: 'group-photoalbum-page',
  data:function(){
    return{
      id:this.$route.params.id,
      album_id:undefined,
    }
  },
  computed:{
     ...mapState([
       'groups','appSettings','group'
       ]),
       computeUserAccess(){
         if(!this.group.authorized){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  components: {
    ButtonAction,
    PagePadding,
    ListAlbums,
    ScrollPage,
  },
  methods:{ 
  },// methods{}
  created(){
    
    this.album_id = this.group.album_id;
   
  }
}

    
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
